import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CampanhaRecursoViewComponent } from './campanha-recurso-view.component';
import { CampanhaPedidoViewModule } from '../../pedidos/view';
import { RecursoCampanhaFormModule } from '../../../recursos/components/form';

@NgModule({
    imports: [
        SharedModule,
        RecursoCampanhaFormModule,
        CampanhaPedidoViewModule
    ],
    declarations: [
        CampanhaRecursoViewComponent
    ],
    exports: [
        CampanhaRecursoViewComponent
    ]
})
export class CampanhaRecursoViewModule { }
